module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/social/youtube-cb1a56785579560cb80bf1a5dc64c713.svg";